import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { adminApi } from "../../lib/adminApi";
import { ScrollText } from "lucide-react";

const COLORS = {
  admin_login: "#4CAF50", change_user_tier: "#FF8F00", suspend_user: "#FF8F00",
  delete_user: "#D32F2F", delete_admin: "#D32F2F", create_admin: "#4CAF50",
  send_push_campaign: "#7B1FA2", send_email_campaign: "#7B1FA2",
  create_promo_code: "#FFD54F", delete_promo_code: "#D32F2F",
  approve_pending_content: "#4CAF50", reject_pending_content: "#FF8F00",
};

export default function AuditLogScreen() {
  const [events, setEvents] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await adminApi.get("/audit-log?limit=200");
        setEvents(data.events || []);
      } catch {}
    })();
  }, []);

  return (
    <AdminLayout>
      <h1 className="text-2xl font-bold text-shadow-green mb-1">Audit Log</h1>
      <p className="text-muted-soft text-sm mb-6">All admin actions, timestamped and immutable.</p>

      <div className="glass-card overflow-hidden">
        <div className="px-4 py-3 border-b border-white/5 flex items-center gap-2">
          <ScrollText size={14} className="text-[#4CAF50]" />
          <p className="text-sm font-semibold">{events.length} recent events</p>
        </div>
        {events.length === 0 ? (
          <p className="p-10 text-center text-soft text-sm">No events yet.</p>
        ) : (
          <div className="max-h-[700px] overflow-y-auto">
            {events.map((e, idx) => (
              <div key={e.event_id || idx} className="px-4 py-3 border-b border-white/3 last:border-b-0" data-testid={`audit-${idx}`}>
                <div className="flex items-start gap-3">
                  <span className="w-2 h-2 rounded-full mt-2 flex-shrink-0" style={{ background: COLORS[e.action] || "#4CAF50", boxShadow: `0 0 8px ${COLORS[e.action] || "#4CAF50"}` }} />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold">{e.action.replace(/_/g, " ")}</p>
                    <p className="text-[11px] text-muted-soft mt-0.5">by <code className="text-white/70">{e.admin_id}</code> · {new Date(e.timestamp).toLocaleString()}</p>
                    {e.details && Object.keys(e.details).length > 0 && (
                      <pre className="text-[11px] text-soft mt-1 bg-black/30 rounded p-2 max-w-full overflow-x-auto">{JSON.stringify(e.details)}</pre>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
